import { Link } from 'react-router-dom';
import { T } from '../components/courses/theme';
import { KRIPTO3_STATE, PODIA_COURSE_URL, SUPPORT_EMAIL } from '../config/podia';

// Old Podia links (/courses/…, /products/…, /bundles/… and the other Podia
// storefront paths, see PODIA_PATHS in App.js) used to fall through to the
// catch-all and land on /login with no explanation. This page says what
// happened and where to go. Same message as the PodiaHint on the login page.

const PodiaMovedPage = ({ session }) => {
  const loggedIn = !!session;
  return (
    <div style={{ minHeight: '100vh', background: T.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '48px 16px' }}>
      <main style={{
        width: '100%', maxWidth: 480, padding: '32px 28px', borderRadius: T.radius,
        background: T.surface, border: `1px solid ${T.line}`, textAlign: 'center',
      }}>
        <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: '0.08em', color: T.accent, textTransform: 'uppercase' }}>
          Web3 Kurzus egyetem
        </div>
        <h1 style={{ margin: '12px 0 12px', color: T.text, fontSize: 26, fontWeight: 800, letterSpacing: '-0.01em', lineHeight: 1.2 }}>
          A tanfolyamok átköltöztek
        </h1>
        <p style={{ margin: '0 0 22px', color: T.body, fontSize: 15, lineHeight: 1.6 }}>
          {loggedIn
            ? 'A tanfolyamaid mostantól itt, az egyetemen vannak. A Podián vásárolt hozzáférésed ugyanahhoz az e-mail-címhez tartozik.'
            : 'Lépj be ugyanazzal az e-mail-címmel, amivel a Podián vásároltál.'}
        </p>
        {loggedIn ? (
          <Link to="/tanfolyamok" style={buttonStyle}>Tovább a tanfolyamaidhoz →</Link>
        ) : (
          <Link to="/login" style={buttonStyle}>Belépés →</Link>
        )}
        {KRIPTO3_STATE === 'partial' && (
          <p style={{ margin: '22px 0 0', color: T.muted, fontSize: 13, lineHeight: 1.6 }}>
            A Kriptovaluta Tanfolyam 3.0 teljes anyaga egyelőre a Podián is megvan
            {PODIA_COURSE_URL ? <>: <a href={PODIA_COURSE_URL} style={{ color: T.accent }}>megnyitom a Podián</a></> : ''}.
          </p>
        )}
        <p style={{ margin: '14px 0 0', color: T.faint, fontSize: 12, lineHeight: 1.6 }}>
          Nem találod a vásárlásodat? Írj a {SUPPORT_EMAIL} címre, és add meg a Podián használt e-mail-címedet.
        </p>
      </main>
    </div>
  );
};

const buttonStyle = {
  display: 'inline-block', background: T.accent, color: '#061214', textDecoration: 'none',
  borderRadius: 12, padding: '13px 24px', fontSize: 15, fontWeight: 700,
  boxShadow: '0 8px 24px -10px rgba(0,210,200,0.55)',
};

export default PodiaMovedPage;
